module.exports = __webpack_public_path__ + "static/media/WIF.4a2a168c.jpg";